import { CARD_TYPES } from '../constants/constants';

export const feeTypes = {
    DIGITAL_ACTIVATION: 'ACTV',
    PLASTIC_ACTIVATION: 'PLAC',
    UYOP: 'UYOP'
};

export const getFeeAmountByTypeAndCost = (fees = [], feeType, certAmount = '0', programCode = 'DEFAULT') => {
    if (fees.length === 0) {
        return 0.00;
    }
    if (!certAmount) {
        return 0.00;
    }
    let feesForType = fees.filter(fee => fee.type === feeType && fee.programCode === programCode);
    if (feesForType.length === 0 || feesForType[0].tiers.length === 0) {
        
        feesForType = fees.filter(fee => fee.type === feeType && fee.programCode === 'DEFAULT');
        if (feesForType.length === 0) {
            return 0.00;
        }
    }
    let currentAmount = 0.00;
    let currentThreshold = 0.00;
    feesForType.forEach(fee => fee.tiers.forEach((tier) => {
        if ((currentThreshold <= Number(tier.threshold))
            && (Number(tier.threshold) <= Number(certAmount))) {
            currentAmount = Number(tier.amount);
            currentThreshold = Number(tier.threshold);
        }
    }));
    return currentAmount;
};

export const getFeeTypeFromItem = (item) => {
    if (item.get('itemCardType') === CARD_TYPES.Physical) {
        if (item.get('UYOPImageURL')) {
            return feeTypes.UYOP;
        }
        return feeTypes.PLASTIC_ACTIVATION;
    }
    return feeTypes.DIGITAL_ACTIVATION;
};

export const calculateUyoFeeTotals = (items, fees = []) => {
    let uyoFeeTotal = 0;
    let uyoFeeCount = 0;

    items.forEach((item) => {
        if (!item || item.get('removed') || getFeeTypeFromItem(item) !== feeTypes.UYOP) {
            return;
        }
        const amount = Number(item.get('cardValue'));
        const quantity = item.get('quantity') || 1;
        const uyoFeeAmount = getFeeAmountByTypeAndCost(fees, feeTypes.UYOP, amount, item.get('programCode'));
        if (uyoFeeAmount) {
            uyoFeeCount += quantity;
            uyoFeeTotal += (quantity * uyoFeeAmount);
        }
    });

    return { uyoFeeTotal, uyoFeeCount };
};
